import React from 'react';
import '../css/activityIndicator.scss';

type ActvivityIndicatorProps = {
  nonTransparent?: boolean;
};

const ActivityIndicator = (props: ActvivityIndicatorProps): JSX.Element => {
  return (
    <div className={props.nonTransparent ? 'activityIndicator nonTransparent' : 'activityIndicator'}>
      <span>Loading...</span>
    </div>
  );
};

export default ActivityIndicator;
